(function() {

	angular
		.module('ngmvac')
		.filter('searchBrandFilter', SearchBrandFilter);

	function SearchBrandFilter() {
		return function(cars, brands) {
			var items = [];
			angular.forEach(cars, function(car, index){
				angular.forEach(brands, function(brand){
					if(car.brand == brand.name && brand.checked){
						items.push(car);
					}
				});
				// if(car.brand == param){
                //     items.push(car);
                // }
			});

			if(items.length == 0){
				return cars;
			}

			return items;
		}
	}

})();